import FileUploadService from "../../../services/FileUploadService";

const Save = (props) => {
    const response = FileUploadService.save({...props});
    return response;
};

export default Save;